import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableHead, TableRow } from '@mui/material';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';
import { Button } from '@totalsoft/rocket-ui';
import AddIcon from "@mui/icons-material/Add";

const FinancialProductResidualGridsTableHead = ({ canWrite, onAdd, isNewFinancialProduct }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={20}>{t("FinancialProduct.Details.ResidualValueGrids.ResidualGrid")}</TableCellWithWidth>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={20}>{t("FinancialProduct.Details.ResidualValueGrids.MaximumIncrease")}</TableCellWithWidth>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={10}>{t("FinancialProduct.Details.ResidualValueGrids.MaximumDecrease")}</TableCellWithWidth>
        <TableCellWithWidth w={10} align="right">
          <Button color="primary" variant="contained" startIcon={<AddIcon />} disabled={!isNewFinancialProduct || !canWrite} onClick={onAdd}>
            {t("Add")}
          </Button>
        </TableCellWithWidth>
      </TableRow>
    </TableHead>
  );
};

FinancialProductResidualGridsTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isNewFinancialProduct: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default FinancialProductResidualGridsTableHead;
